import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../config/axiosInterceptor";
import {
  BulkUploadType,
  CreateEquipmentType,
  CreateMaterialType,
} from "./types";
import { RcFile } from "antd/es/upload";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const createMaterial = (
  payload: CreateMaterialType
): Promise<AxiosResponse<CreateMaterialType>> => {
  return axios.post(`${baseURL}createMaterial`, payload);
};

export const updateMaterialById = (
  id: string,
  payload: CreateMaterialType
): Promise<AxiosResponse<CreateMaterialType>> => {
  return axios.patch(`${baseURL}updateMaterialById/${id}`, payload);
};

export const deleteMaterial = (
  materialIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteMaterial`, { data: materialIds });
};

export const createEquipment = (
  payload: CreateEquipmentType
): Promise<AxiosResponse<CreateEquipmentType>> => {
  return axios.post(`${baseURL}createEquipment`, payload);
};

export const deleteEquipment = (
  materialIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteEquipment`, { data: materialIds });
};

export const updateEquipmentById = (
  id: string,
  payload: CreateMaterialType
): Promise<AxiosResponse<CreateMaterialType>> => {
  return axios.patch(`${baseURL}updateEquipmentById/${id}`, payload);
};

export const materialBulkUpload = (
  payload: BulkUploadType[]
): Promise<AxiosResponse<BulkUploadType>> => {
  return axios.post(`${baseURL}materialBulkUpload`, payload);
};

export const materialBulkUploadCSV = async ({
  company_id,
  files,
}: {
  company_id: string;
  files: RcFile | File;
}): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("company_id", company_id);
  formData.append("files", files);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${baseURL}materialBulkUploadCSV`, formData, config);
};

export const equipmentBulkUpload = (
  payload: BulkUploadType[]
): Promise<AxiosResponse<BulkUploadType>> => {
  return axios.post(`${baseURL}equipmentBulkUpload`, payload);
};

export const equipmentBulkUploadCSV = async ({
  company_id,
  files,
}: {
  company_id: string;
  files: RcFile | File;
}): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("company_id", company_id);
  formData.append("files", files);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${baseURL}equipmentBulkUploadCSV`, formData, config);
};
